import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';
import { environment } from '@env/environment';
import {
  CancelTicketProps,
  EditTicketProps,
  UpdateARProps,
  UpdateInteractionHistoryProps,
  UpdateShippingProps
} from '@routes/b2b/tickets/shared/ticket-update.model';

@Injectable({
  providedIn: 'root'
})
export class B2bTicketApi extends ApiCommon {
  protected backend = environment.api.backend;

  getTickets(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.b2bTicket.getTickets(builder.build());
  }

  exportTickets(builder): Observable<any> {
    return this.apiServer.b2bTicket.exportTickets(builder);
  }

  getStatusSummary(builder): Observable<any> {
    return this.apiServer.b2bTicket.getStatusSummary(builder);
  }

  getStateSummary(builder): Observable<any> {
    return this.apiServer.b2bTicket.getStateSummary(builder);
  }

  getTicket(ticketNo: any): Observable<any> {
    return this.apiServer.b2bTicket.getTicket(ticketNo);
  }

  getArGood(partnerOrganization, modelCode): Observable<any> {
    return this.apiServer.b2bTicket.getArGood(partnerOrganization, modelCode);
  }

  updateTicketSync(ticketNo: any): Observable<any> {
    return this.apiServer.b2bTicket.updateTicketSync(ticketNo);
  }

  updateTicketSyncWithPartnerCall(ticketNo: any): Observable<any> {
    return this.apiServer.b2bTicket.updateTicketSyncWithPartnerCall(ticketNo);
  }

  updateTicket(data: EditTicketProps): Observable<any> {
    return this.apiServer.b2bTicket.updateTicket(data);
  }

  updateShipping(data: UpdateShippingProps): Observable<any> {
    return this.apiServer.b2bTicket.updateShipping(data);
  }

  cancelTicket(data: CancelTicketProps): Observable<any> {
    return this.apiServer.b2bTicket.cancelTicket(data);
  }

  updateAR(data: UpdateARProps): Observable<any> {
    return this.apiServer.b2bTicket.updateAR(data);
  }

  updateRmaNo(data): Observable<any> {
    return this.apiServer.b2bTicket.updateRmaNo(data);
  }

  updateSerialNo(data): Observable<any> {
    return this.apiServer.b2bTicket.updateSerialNo(data);
  }

  updateSubStatus(data): Observable<any> {
    return this.apiServer.b2bTicket.updateSubStatus(data);
  }

  updateReturnSubStatus(data): Observable<any> {
    return this.apiServer.b2bTicket.updateReturnSubStatus(data);
  }

  updateAgentComment(data): Observable<any> {
    return this.apiServer.b2bTicket.updateAgentComment(data);
  }

  forceRevert(data): Observable<any> {
    return this.apiServer.b2bTicket.forceRevert(data);
  }

  updateInteractionHistory(data: UpdateInteractionHistoryProps): Observable<any> {
    return this.apiServer.b2bTicket.updateInteractionHistory(data);
  }

  requestSubmitTicket(data): Observable<any> {
    return this.apiServer.b2bTicket.requestSubmitTicket(data);
  }

  updateTrackingStatus(data): Observable<any> {
    return this.apiServer.b2bTicket.updateTrackingStatus(data);
  }

  deleteTicketBosFile(data): Observable<any> {
    return this.apiServer.b2bTicket.deleteTicketBosFile(data);
  }

  deleteTicketFile(data): Observable<any> {
    return this.apiServer.b2bTicket.deleteTicketFile(data);
  }

  changePartnerOrganization(data): Observable<any> {
    return this.apiServer.b2bTicket.changePartnerOrganization(data);
  }
}
